export class PrescriptionSolutionMedicine {
    public idPrescriptionSolutionMedicine: number;
    public idPrescriptionSolution: number;
    public idMedicine: number;
    public quantity: number;
    public datetimeInclusion: Date;
    public idPrescriptionStatus: number;
    public idMeasurementUnit: number;
    public idDoseToAdministered: number;
    public nonDispensationReason: string;
    public nonDispensationIdUser: number;
    public justification: string;
    public datetimeNonDispensation: Date;
    public idUserRelease: number;
    public calculatedTotalQuantity: number;
    public datetimeRelease: Date;
}